"use client";

import { Typography } from "@/components/ui/typography";
import type { ServicesIndustryCardsProps } from "./types";
import { servicesIndustryCardsMap } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import IndustryCardsCarousel from "@/components/screen/global-components/industry/IndustryCardsCarousel";

const ServicesIndustryCards = ({
  variant = "enterprise",
  className,
}: ServicesIndustryCardsProps) => {
  const {
    cards,
    content: { title, description },
  } = servicesIndustryCardsMap[variant];

  return (
    <section
      className={cn(
        "section overflow-hidden border-b border-b-neutral-200 md:border-b-0",
        className
      )}
    >
      <div className="container mx-auto py-12 lg:py-20">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8">
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          <Typography variant="subHeadingSm" className="text-gray-600" asChild>
            <p>{description}</p>
          </Typography>
        </div>
        <IndustryCardsCarousel cards={cards} className="mt-6 lg:!mt-12" />
      </div>
    </section>
  );
};

export default memo(ServicesIndustryCards);
